export enum CLASS_LETTER_EDITOR_VIEW {
    WITH_QUOTES = 'with-quotes',
    PLAIN = 'plain',
    COLLEGE = 'collge',
}
